import React from 'react'
import { SnackbarProvider } from 'notistack'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
    success: {
        backgroundColor: theme.active
    },
    error: {
        backgroundColor: theme.error
    },
    warning: {
        backgroundColor: theme.warning
    },
    info: {
        backgroundColor: theme.primary
    }
}))

export default function SnackbarCustomProvider(props) {
    const classes = useStyles()
    return (
        <SnackbarProvider
            classes={{
                variantSuccess: classes.success,
                variantError: classes.error,
                variantWarning: classes.warning,
                variantInfo: classes.info,
            }}
        >
            {props.children}
        </SnackbarProvider>
    )
}